export default "__VITE_ASSET__DeiJqvtn__"